import { render, staticRenderFns } from "./DishRankingCenter.vue?vue&type=template&id=53444076&scoped=true&lang=pug"
import script from "./DishRankingCenter.vue?vue&type=script&lang=js"
export * from "./DishRankingCenter.vue?vue&type=script&lang=js"
import style0 from "./DishRankingCenter.vue?vue&type=style&index=0&id=53444076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53444076",
  null
  
)

export default component.exports